// frontend/src/components/common/UI/Spinner.tsx

import React from 'react'
import { cn } from '@/utils/helpers'

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  className
}) => {
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  }

  return (
    <div className="flex items-center justify-center">
      <div
        className={cn(
          'animate-spin rounded-full border-4 border-secondary-200 border-t-primary-600',
          sizes[size],
          className
        )}
      />
    </div>
  )
}